import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=e57d0c1c&scoped=true&"
import script from "./Permits.vue?vue&type=script&lang=js&"
export * from "./Permits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57d0c1c",
  null
  
)

export default component.exports